import { render, staticRenderFns } from "./StorageSideNav.vue?vue&type=template&id=49f8c398&scoped=true&"
import script from "./StorageSideNav.vue?vue&type=script&lang=js&"
export * from "./StorageSideNav.vue?vue&type=script&lang=js&"
import style0 from "./StorageSideNav.vue?vue&type=style&index=0&id=49f8c398&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f8c398",
  null
  
)

export default component.exports